import { render, staticRenderFns } from "./SuggestedAssignmentList.vue?vue&type=template&id=38c3e0fe&scoped=true"
import script from "./SuggestedAssignmentList.vue?vue&type=script&lang=js"
export * from "./SuggestedAssignmentList.vue?vue&type=script&lang=js"
import style0 from "./SuggestedAssignmentList.vue?vue&type=style&index=0&id=38c3e0fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c3e0fe",
  null
  
)

export default component.exports